import React, { useEffect } from "react";
import useBeforeUnload from "features/common/hooks/useBeforeUnload";
import SaveWarningModal from "./SaveWarningModal";
import useMediaView from "features/common/hooks/useMediaView";
import MobilePageCover from "components/Common/MobilePageCover/MobilePageCover";
import UserDetailWebPage from "./(web)/UserDetailWebPage";
import UserDetailMobilePage from "./(mobile)/UserDetailMobilePage";
import { useNavigate, useParams } from "react-router-dom";
import useUsersDetailQuery from "features/user/hooks/queries/useUsersDetailQuery";
import { LeftIcon } from "assets/icons";
import { FormProvider, useForm } from "react-hook-form";

interface FormData {
  companyName: string;
  companyDepartment: string;
  companyPosition: string;
  authority: string;
  isAdmin: boolean;
  isDecisionManager: boolean;
}

const UserDetailPage = () => {
  const {
    isBlock,
    blocking,
    process,
    enableUnloadTracking,
    disableUnloadTracking,
  } = useBeforeUnload({
    isInitialTracking: false,
  });
  const navigate = useNavigate();
  const isSmall = useMediaView("small");

  const { id } = useParams();
  if (!id) {
    throw new Error("url params id is required");
  }
  const { data } = useUsersDetailQuery(id);
  const userData = data.data.result.user;

  const methods = useForm<FormData>({
    defaultValues: {
      companyName: userData.companyName,
      companyDepartment: userData.companyDepartment,
      companyPosition: userData.companyPosition,
      authority: userData.assignedAuthorityDto?.uuid ?? null,
      isAdmin: userData.isAdmin,
      isDecisionManager: userData.isDecisionManager,
    },
  });

  useEffect(() => {
    methods.formState.isDirty && enableUnloadTracking();
    return () => {
      disableUnloadTracking();
    };
  }, [disableUnloadTracking, enableUnloadTracking, methods.formState.isDirty]);

  if (!data?.data) return;

  return (
    <>
      <SaveWarningModal
        isOpen={isBlock}
        onConfirm={process}
        onCancel={blocking}
      />
      <FormProvider {...methods}>
        {!isSmall && (
          <UserDetailWebPage
            userData={userData}
            disableUnloadTracking={disableUnloadTracking}
          />
        )}
        {isSmall && (
          <MobilePageCover header={<LeftIcon onClick={() => navigate(-1)} />}>
            <UserDetailMobilePage
              userData={userData}
              disableUnloadTracking={disableUnloadTracking}
            />
          </MobilePageCover>
        )}
      </FormProvider>
    </>
  );
};

export default UserDetailPage;
